import { Model_ResponseWorkflow, QueryParams_ResponseWorkflow } from 'src/app/app.models';

export abstract class ResponseWorkflowOfflineDao {
    abstract doSyncResponsesAction(_responses: Model_ResponseWorkflow[]): Promise<void>;
    abstract doClearResponsesAction(): Promise<void>;
    abstract doGetResponsesAction(_queryParams?: any): Promise<Model_ResponseWorkflow[]>;
    abstract doInsertResponsesAction(_responses: Model_ResponseWorkflow[]): Promise<void>;
    abstract doSaveResponsesAction(_response: Model_ResponseWorkflow): Promise<Model_ResponseWorkflow>;
    abstract doGetResponseAction(_guid: string): Promise<Model_ResponseWorkflow>;
    abstract doDeleteResponseWorkflowAction(_guid: string): Promise<void>;
}